import { cn } from "@/lib/utils/cn";
import { Button } from "@/ui-components/ui/button";
import { Column } from "@tanstack/react-table";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

export type DataTable2SortDirection = "asc" | "desc";

export interface DataTable2ColumnHeaderProps<TData, TValue> {
  column: Column<TData, TValue>;
  title: string;
  className?: string;
}

export function DataTable2ColumnHeader<TData, TValue>({ column, title, className }: DataTable2ColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <div className={cn("text-xs font-medium text-gray-500", className)}>{title}</div>;
  }

  const sorted = column.getIsSorted() as false | DataTable2SortDirection;
  const Icon = sorted === "asc" ? ArrowUp : sorted === "desc" ? ArrowDown : ArrowUpDown;

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={column.getToggleSortingHandler()}
      className={cn(
        "-ml-2 h-8 px-2 text-xs font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md group",
        className
      )}
    >
      <span>{title}</span>
      <Icon className={cn("ml-2 h-3.5 w-3.5", sorted ? "text-gray-600" : "text-gray-400 group-hover:text-gray-600")} />
    </Button>
  );
}
